// Stands in for a Select inside a SecureFormItem/Form.Item when the viewer
// has no Sup-View/Admin-View access - Form.Item clones its single child with
// `value` (and `onChange`), so this still receives and displays the real
// bound value (e.g. "Pending") as text instead of rendering an editable
// dropdown, while keeping the field registered in the antd form for save.
const ApprovalReadOnlyValue = ({ value, options = [] }) => {
  const label = options?.find((opt) => opt?.value === value)?.label ?? value ?? "";
  return <span style={{ fontWeight: 600 }}>{label}</span>;
};

export default ApprovalReadOnlyValue;
